module.exports = __webpack_public_path__ + "static/img/12.c689e1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/12.jpg
// module id = V2NY
// module chunks = 1